import { AfterViewInit, Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

/**
 * Directive to apply the primary color of the hotel to the text element.
 */
@Directive({
  selector: '[ctrHotelColor]',
  standalone: true,
})
export class HotelColorDirective implements AfterViewInit {
  @Input() colorType: 'primary' | 'contrast' = 'primary';

  private elementRef = inject(ElementRef);
  private render = inject(Renderer2);

  /**
   * Lifecycle hook that is called after the view has been initialized.
   * It retrieves the primary color of the hotel from the CSS variables and applies it to the text element.
   */
  ngAfterViewInit(): void {
    if (this.colorType === 'primary') {
      this.render.setStyle(this.elementRef.nativeElement, 'color', 'var(--ctr-primary-color)');
    } else {
      this.render.setStyle(this.elementRef.nativeElement, 'color', 'var(--ctr-contrast-color)');
    }
  }
}
